import axios, {AxiosInstance} from 'axios';

const instance: AxiosInstance = axios.create({
    baseURL: "http://api.zyai.ac.cn/",
});

instance.interceptors.request.use(async (config: any) => {
    return config;
}, (error) => {
    return Promise.reject(error);
});

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            let message = error.response.data.message;
            for (const key in error.response.data.data) {
                if (error.response.data.data.hasOwnProperty(key)) {
                    message += ' : ' + error.response.data.data[key];
                }
            }
            return Promise.reject(new Error(message || '未知错误'));
        } else {
            return Promise.reject(new Error('网络错误，请检查网络连接'));
        }
    },
);
export const HttpService = instance;
